export default __webpack_public_path__ + "static/media/your-modules-icon.36199701.svg";